import { Trash2, Edit2 } from "lucide-react";

export const BulkActionBar = ({
  selectedCount, onBulkDelete, bulkEditField, setBulkEditField,
  bulkEditValue, setBulkEditValue, onBulkEdit, onClear
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className="flex items-center gap-3 px-3 py-2 bg-orange-600/10 border-b border-orange-500/30" data-testid="bulk-actions-bar">
      <span className="text-orange-400 text-xs font-bold uppercase">{selectedCount} selected</span>
      <button onClick={onBulkDelete} className="flex items-center gap-1 px-2 py-1 bg-red-600 text-white text-[10px] font-bold uppercase hover:bg-red-500" data-testid="bulk-delete-btn">
        <Trash2 className="w-3 h-3" /> Delete
      </button>
      <select value={bulkEditField} onChange={(e) => setBulkEditField(e.target.value)} className="bg-zinc-800 text-white text-[10px] px-2 py-1 border border-white/10" data-testid="bulk-edit-field-select">
        <option value="">Edit field...</option>
        <option value="sport">Sport</option>
        <option value="channel_id">Channel</option>
        <option value="event_id">Event</option>
        <option value="scheduled_date">Date</option>
        <option value="scheduled_time">Time</option>
      </select>
      {bulkEditField && (
        <>
          <input
            type={bulkEditField === "scheduled_date" ? "date" : bulkEditField === "scheduled_time" ? "time" : "text"}
            value={bulkEditValue} onChange={(e) => setBulkEditValue(e.target.value)}
            placeholder="New value..." className="bg-zinc-800 text-white text-[10px] px-2 py-1 border border-white/10 w-32"
            data-testid="bulk-edit-value-input"
          />
          <button onClick={onBulkEdit} className="flex items-center gap-1 px-2 py-1 bg-blue-600 text-white text-[10px] font-bold uppercase hover:bg-blue-500" data-testid="bulk-edit-apply-btn">
            <Edit2 className="w-3 h-3" /> Apply
          </button>
        </>
      )}
      <button onClick={onClear} className="ml-auto text-zinc-400 text-[10px] uppercase hover:text-white">Clear</button>
    </div>
  );
};
